<template>
  <div class="f-col">
    <p :class="brandClasses.passkeyDescription">
      {{ $t.mfa.passkeyIntro }}
    </p>

    <p class="mt-4" :class="brandClasses.passkeyDescription">
      {{ $t.mfa.passkeyVerifyAccount }}
    </p>

    <vf-button class="mt-16 w-full" :class="brandClasses.passkeyCta" @click="onContinue">
      {{ $t.continue }}
    </vf-button>

    <div v-if="lookupData.authMethods.length > 1" class="mt-6 w-full text-center" :class="brandClasses.tryAnotherWay">
      <vf-link class="fw-bold" @click="emit('continue', EnrollmentState.SIGNIN_OPTIONS)">
        {{ $t.mfa.tryAnotherWay }}
      </vf-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { LookupData } from '#root/api/clients/consumer/data-contracts'
import { EnrollmentState } from '#root/enums/profile'

const { lookupData } = defineProps<{ lookupData: LookupData }>()

const emit = defineEmits<{
  continue: [state: EnrollmentState]
}>()

const recaptcha = useRecaptcha()
const { authentication } = useApi()
const { brandClasses } = useAppConfig().components.dialog.simplifiedEnrollment

const onContinue = async () => {
  const { codeChallenge } = await getPkceCodePair()
  const captchaResponse = await recaptcha.execute('login')

  try {
    await authentication.$mfa({
      authMethod: 'passkey',
      username: lookupData.email,
      codeChallenge,
      recaptcha_response: captchaResponse,
      action: 'authorization'
    })
    emit('continue', EnrollmentState.OTP)
  }
  catch (err: any) {
    log.error('Error during passkey authentication:', err)
  }
}
</script>
